<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">課題列表</div>
        </el-col>
        <el-col :span="4" style="text-align:right;">
          <i style="font-size:20px;cursor: pointer;" @click="onIconClose" class="el-icon-close"></i>
        </el-col>
      </el-row>

      <div class="page-box">
        <el-row :gutter="24" class="page-content-row">
          <el-col :span="3">
            <el-input
                v-model="listQuery.numberLike"
                placeholder="請輸入課題編號"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="listQuery.lang" placeholder="請選擇課程版本">
              <el-option
                  v-for="item in languages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="listQuery.gradeId" placeholder="請選擇年級">
              <el-option
                  v-for="(item, index) in $store.getters.grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button size="small" type="info" @click="onSearch">搜尋</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="small" type="info" @click="batchSelect">批量選擇（可多選）</el-button>
          </el-col>
        </el-row>

        <!-- 折叠面板布局 → 支持同时展开多个 -->
        <div class="collapse-layout">
          <div
              v-for="item in topicsTableData"
              :key="item.id"
              class="collapse-item"
          >
            <!-- 点击标题：折叠/展开 -->
            <div
                class="collapse-header"
                @click="togglePanel(item.id)"
            >
              <div class="topic-num">{{ item.number }}</div>
              <div class="topic-name">{{ item.name }}</div>
              <div class="topic-name">{{ item.gradeName }}</div>
              <div class="topic-name">{{item.scope | scope}}</div>
              <el-tag size="mini" :type="item.lang === 0 ? 'warning' : 'success'">
                {{ item.lang | language }}
              </el-tag>
              <i class="el-icon-arrow-right" :class="{ open: expandedIds.includes(item.id) }"></i>
            </div>

            <!-- 展开内容：表格 -->
            <div
                class="collapse-body"
                v-show="expandedIds.includes(item.id)"
            >
              <el-table
                  v-loading="loadingMap[item.id]"
                  :data="tableDataMap[item.id] || []"
                  style="width: 100%"
                  @selection-change="(val) => handleSelectionChange(val, item.id)"
              >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="練習" align="left" width="300px">
                  <template slot-scope="{row}">
                    <div class="describe-text">{{ row.practiseNumber }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="medium" @click="onSelect(row)">選擇</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="topicsTableData.length === 0" class="empty-topic">暫無數據</div>
        </div>

        <!-- 分页 -->
        <div class="pagination-container" v-show="topicsTotal > 0">
          <div class="simple-pagination">
            <span>共 {{ topicsTotal }} 條</span>
            <div class="btns">
              <el-button
                  size="mini"
                  icon="el-icon-arrow-left"
                  :disabled="listQuery._page === 1"
                  @click="listQuery._page--; getTopicsGroup()"
              >上一頁
              </el-button>
              <el-button
                  size="mini"
                  icon="el-icon-arrow-right"
                  :disabled="listQuery._page * listQuery._limit >= topicsTotal"
                  @click="listQuery._page++; getTopicsGroup()"
              >下一頁
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { payStatus } from "@/biz/static-data";
import {getTopicPractiseList, getTopics} from "@/api/topics";
export default {
  props: {
    lang: { type: Number, default: 0 },
    gradeId: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: true,
      selectedRowsMap: {},
      expandedIds: [], // 存储所有展开的面板ID
      tableDataMap: {}, // 存储每个课题的表格数据
      loadingMap: {},   // 存储每个课题的加载状态
      isRelease:[{id:0,name:"未發佈"},{id:1,name:"已發佈"}],
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      listQuery: {
        numberLike: null,
        gradeId: this.gradeId,
        lang: this.lang,
        scope: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      topicsTableData: [],
      topicsTotal: 0,
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getTopicsGroup();
  },
  methods: {
    // 切换折叠面板
    togglePanel(id) {
      const index = this.expandedIds.indexOf(id);
      if (index > -1) {
        this.expandedIds.splice(index, 1);
      } else {
        this.expandedIds.push(id);
        this.loadTopicsData(id);
      }
    },
    // 加载对应课题数据
    loadTopicsData(topicId) {
      const topic = this.topicsTableData.find(t => t.id === topicId);
      if (!topic) return;

      this.$set(this.loadingMap, topicId, true);
      let params = {
        numberLike: topic.number,
        gradeId: this.listQuery.gradeId,
        lang: this.listQuery.lang,
        _page: 0,
        _limit: 999,
      };
      getTopicPractiseList(params).then(res => {
        this.$set(this.tableDataMap, topicId, res.data || []);
      }).finally(() => {
        this.$set(this.loadingMap, topicId, false);
      });
    },
    getTopicsGroup() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      const loading = this.$loading({ lock: true, text: "加載中..." });
      getTopics(params).then(res => {
        this.topicsTableData = res.data || [];
        this.topicsTotal = Number(res.headers["x-total-count"]) || 0;
        this.expandedIds = [];
        this.tableDataMap = {};
        this.loadingMap = {};
      }).finally(() => loading.close());
    },
    // 选择变化
    handleSelectionChange(val, topicId) {
      this.$set(this.selectedRowsMap, topicId, val);
    },
    batchSelect() {
      let all = [];
      Object.values(this.selectedRowsMap).forEach(list => {
        all = all.concat(list);
      });
      if (all.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }
      all.forEach(row => {
        this.$emit('select', { ...row, topicId: row.id, topicNumber: row.number });
      });
    },
    onIconClose(){ this.$emit("iconClose"); },
    onSelect(row){
      this.$emit('select',{...row, topicNumber: row.number, topicId:row.id})
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getTopicsGroup();
    },
    onReset() {
      this.listQuery = {
        numberLike: null, gradeId: null, lang: null, scope: null, orderBy: null, _page: 1, _limit: 10,
      };
      this.getTopicsGroup();
    },
    onSearch() { this.getTopicsGroup(); },
    getTopics() {},
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child { margin-bottom: 0; }
    }
  }
}
.page-box { background-color: #fff; padding: 16px; }
.describe-text{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}

/* 折叠面板布局 */
.collapse-layout {
  width: 100%;
}
.collapse-item {
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 8px;
  overflow: hidden;
}
.collapse-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f9f9f9;
  cursor: pointer;

  .topic-num { min-width: 60px; color: #166ea5; font-weight: 500; }
  .topic-name { flex: 1; }
  i {
    transition: transform 0.3s;
    &.open { transform: rotate(90deg); }
  }
}
.collapse-body {
  padding: 12px;
  border-top: 1px solid #eee;
}
.empty-topic { text-align: center; padding: 30px 0; color: #999; }
.pagination-container { padding: 8px 10px; text-align: center; }
</style>